<template>
  <div id="app" :class="[brandSettings.brand_theme ? brandSettings.brand_theme.name : '', $isElectron ? 'kiosk' : '']">
    <div class="common-overlay" v-if="showCommonOverlay && $isElectron">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
    <test-socket-events />
    <portal-target name="destination" />
    <modal2 v-if="!!showSportsMenuModal" class="mll-modal" :closeable="true" @close="closeSportsMenuModal()">
      <template slot="body"
        ><league-list :is-mobile="true" @clicked="closeSportsMenuModal()"
      /></template>
    </modal2>

    <div class="refresh-trigger-area" v-if="deployModalShowInternal">
      <h3 class="rta-title">
        <span class="rta-loading-count" v-if="deployModalCountDown > 0">{{ deployModalCountDown }}</span>
        {{ $t('Refresh.Title') }}
      </h3>
      <p>{{ $t('Refresh.Description') }}</p>
      <div class="d-flex align-items-center">
        <!--<button class="btn">{{ $t('Refresh.NotNow') }}</button>-->
        <button class="btn refresh-button" @click="reloadPage">{{ $t('Refresh.Click') }}</button>
      </div>
    </div>

    <!-- SUCCESS MODAL -->
    <modal
      class="generic-success-modal"
      v-if="successModal.show"
      type="success"
      :closeable="successModal.isClosable"
      @close="$modal.closeSuccessModal()"
    >
      <div class="text-center" slot="body">
        <h3 v-if="successModal.title">{{ $t(successModal.title || 'Success') }}</h3>
        {{ $t(successModal.content) }}
      </div>
    </modal>

    <!-- ERROR MODAL -->

    <modal v-if="errorModal.show" type="error" :closeable="errorModal.isClosable" @close="$modal.closeErrorModal()">
      <div class="text-center" slot="body">
        <h3 v-if="errorModal.title">{{ $t(errorModal.title || 'Error') }}</h3>
        {{ $t(errorModal.content) }}
      </div>
    </modal>

    <app-header v-if="!terminalInfoError && !isPartialLoading"></app-header>
    <barcode-scanner-modal
      class="barcode-scanner-modal"
      @close="showScanBarcodeModal = false"
      v-if="showScanBarcodeModal"
    ></barcode-scanner-modal>
    <router-view v-if="!appLoading || !isPartialLoading" />
    <app-footer
      v-if="!terminalInfoError && !$isElectron && !$route.meta.footerDisabled && !isPartialLoading"
    ></app-footer>
    <div
      class="app-loader"
      style="z-index: 100000"
      v-if="terminalInfoError || appLoading || isPartialLoading"
      :class="pageUrl"
    >
      <div class="app-loader-inside">
        <img src="@/assets/images/instabet_loading.gif" alt="Loading..." width="36" class="mb-2" />
        <h1 class="loading-dots">
          {{
            selectedLocale.short_code === 'es'
              ? 'Cargando'
              : selectedLocale.short_code === 'pt'
              ? 'Carregando'
              : selectedLocale.short_code === 'en'
              ? 'Loading'
              : ''
          }}
        </h1>
      </div>
    </div>
    <terminal-not-found v-if="terminalExists === false"></terminal-not-found>

    <bottom-menu
      :is-clerk="isClerk"
      :is-partial-loading="isPartialLoading"
      :should-disable-casino="shouldDisableCasino"
      @goIfLogged="goIfLogged"
    />

    <modal type="danger" v-if="showNeedLoginModal" @close="showNeedLoginModal = false" :closeable="true">
      <h1 slot="body" class="text-center">{{ $t('NeedLogin') }}</h1>
    </modal>
    <modal type="danger" v-if="terminalInfoError" :closeable="false">
      <div slot="body">
        <h1 class="text-center">{{ $t('Error.TerminalSettingsError') }}</h1>
        <p class="text-center m-0" v-for="err in terminalInfoError">
          {{ err }}
        </p>
        <div class="d-flex">
          <button class="btn btn-danger btn-lg ml-auto mr-auto mt-3" @click="window.close()">Close</button>
        </div>
      </div>
    </modal>

    <modal
      type="success"
      v-if="newTerminalRequest"
      :closeable="false"
      style="z-index: 99999999999999999; overflow: hidden"
    >
      <div slot="body">
        <h3 class="text-center">
          #{{ newTerminalRequest }}<br />
          Su petición ha sido recibida
        </h3>
        <div class="d-flex">
          <button class="btn btn-orange ml-auto mr-auto mt-3" @click="reloadPage()">Inténtalo de nuevo</button>
        </div>
      </div>
    </modal>

    <ModalPage
      isModal
      width="80%"
      @closed="setBetsConfirmationModal(false)"
      v-if="betsConfirmationModal"
      :title="$t('ClerkPayout.Title')"
    >
      <div slot="body">
        <BetsHistory :isSportsbook="true" :bets="ticketAllBets">
          <ticket-line-details
            class="mt-3"
            v-if="$store.state.depositTicketStore.scanDetailsData"
            :ticket-open-bets="$store.state.depositTicketStore.modalOpenBets"
            :ticket-graded-bets="$store.state.depositTicketStore.modalGradedBets"
            :scan-detail-response="$store.state.depositTicketStore.scanDetailsData"
          />
        </BetsHistory>
      </div>
    </ModalPage>

    <modal
      v-if="sportsBookPayoutSuccessModal"
      type="success"
      :closeable="true"
      @close="setSportsBookPayoutSuccessModal(false)"
    >
      <div slot="body">
        <h3 class="text-center">{{ $t('SportsBookPayout.PayoutSuccess') }}</h3>
      </div>
    </modal>

    <!-- Twitter universal website tag code -->
    <component :is="'script'">
      !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
      },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
      a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');twq('init','o4o0x');
      twq('track','PageView');
    </component>
    <!-- End Twitter universal website tag code -->

    <modal :closeable="false" v-if="rePrintModal.show">
      <div slot="body">
        <h3 class="text-center mt-3">
          {{ $t('RePrint.Question') }}
        </h3>
        <div class="d-flex mt-3">
          <button class="btn btn-green mr-3 flex-grow-1 d-flex justify-content-around" @click="printYes()">
            {{ $t('ClerkSession.Yes') }} <span>{{ rePrintModal.counter }}</span>
          </button>
          <button class="btn btn-orange flex-grow-1" @click="printNo()">
            {{ $t('ClerkSession.No') }}
          </button>
        </div>
      </div>
    </modal>

    <component :is="'script'">
      !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
      },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
      a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script'); twq('init','o4o0x');
      twq('track','PageView');
    </component>

    <component :is="'script'">
      !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
      },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
      a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script'); twq('init','o4rwj');
      twq('track','PageView');
    </component>

    <simple-keyboard-common v-if="$isElectron && terminalInfo && terminalInfo.can_clerk_login !== '1' && !isScanningCodeForMobile" />

    <BModal
      v-if="openWagerStatusModal"
      class="app-vue-barcode-scan-modal barcode-scan-modal"
      :closeable="true"
      @close="setOpenWagerStatusModal(false)"
    >
      <div slot="header">
        <span class="title">{{ $t('WagerTicket.Information') }}</span>
      </div>
      <div class="confirmation-wrapper" slot="body">
        <div class="rows-wrapper">
          <barcode-scanner-wager-ticket-content></barcode-scanner-wager-ticket-content>
        </div>
      </div>
    </BModal>

    <modal :closeable="true" v-if="showIdleModal && !isScanningCodeForMobile" class="idle-modal" @close="iAmHere()">
      <div slot="body">
        <div class="modal-icon">
          <modal-icon />
        </div>
        <h2 class="text-center">
          {{ $t('Splash.Modal.AreYouThere') }}
        </h2>
        <p class="text-center">
          {{ $t('Splash.Modal.Desc', { count: countDownForIdleModal }) }}
        </p>
        <div class="buttons">
          <a class="btn btn-primary here" @click="iAmHere()"> {{ $t('Splash.Modal.IAmHere') }}</a>
          <a class="btn btn-outline reset" @click="restStateForIdle()"> {{ $t('Splash.Modal.ResetNow') }}</a>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { ExternalWagerLoginTypes, LoginTypes } from '@/utils/enums';
import { log } from '@/utils/logging';
import { version } from '../package.json';
import TerminalNotFound from './views/error/TerminalNotFound';
import { startCheckInactivityAfterReload } from '@/plugins/playerInactivityChecker';
import IdleJs from 'idle-js';
import { mapFields } from 'vuex-map-fields';
import gtm from '@/utils/gtm';
import BarcodeScannerModal from '../src/views/sports/components/clerk/BarcodeScannerModal';
import BetsHistory from '@/views/history/HistoryBetsTableDepositTicket';
import ModalPage from '@/components/shared/ModalPage';
import { setLastVisit } from '@/utils/last-visit';
import { _api } from '@/utils/apiAxios';
import snq from 'snq';
import SimpleKeyboardCommon from '@/views/sports/components/bet-slip/SimpleKeyboardCommon';
import BarcodeScannerWagerTicketContent from '@/views/sports/components/clerk/BarcodeScannerWagerTicketContent';
import BModal from '@/components/shared/BonusModal';
import { socket } from '@/utils/menuSignalR';
import router from '@/router';
import store from '@/store';
import i18n from '@/utils/i18n';
import ModalIcon from '@/views/splash/components/ModalIcon';
import BottomMenu from '@/components/BottomMenu';
import Cookies from 'js-cookie';
import LeagueList from './views/sports/components/LeagueList';
import { isElectronContext } from './utils/isElectron';
import { facebook } from './utils/headerController';
import TicketLineDetails from './views/sports/components/clerk/TicketLineDetails';
import TestSocketEvents from '@/components/TestSocketEvents';
import { insertHotjar } from './plugins/hotjar';

let isElectron = isElectronContext();

let electron;
if (isElectron) {
  electron = window.require && window.require('electron');
}

let idle;
let idle2;

export default {
  components: {
    TestSocketEvents,
    TicketLineDetails,
    LeagueList,
    BottomMenu,
    ModalIcon,
    TerminalNotFound,
    BarcodeScannerModal,
    BetsHistory,
    ModalPage,
    BarcodeScannerWagerTicketContent,
    BModal,
    SimpleKeyboardCommon,
  },
  data() {
    return {
      showNeedLoginModal: false,
      BarcodeScanCode: '',
      window: window,
      currentRoute: '',
      applyBetSlipIconAnim: false,
      ExternalWagerLoginTypes,
      deployModalShow: false,
      deployModalCountDown: 20,
      deployModalShowInternal: false,
      countDownForIdleModal: -1,
    };
  },
  watch: {
    clerk(val) {
      this.redirectToChangePassword(val);
    },
    terminalInfo(val) {
      if (isElectron) {
        this.idleCheck();
      }
    },
    socketConnection(val) {
      if (val === 1) {
        this.listenEposSocket();
      }
    },
    deployModalCountDown(val) {
      if (val === 0) {
        this.reloadPage();
      }
    },
    deployModalShow(val) {
      if (val) {
        this.deployModalControl(this.$route);
      }
    },
    deployModalShowInternal(val) {
      if (val) {
        this.refreshEposTrigger();
      }
    },
    selectedLocale(newValue, oldValue) {
      if (newValue && newValue.short_code) {
        const shortLocale = newValue.short_code;
        this.$i18n.locale = shortLocale;
        if (window.Locale) {
          this.$i18n.setLocaleMessage(shortLocale, window.Locale[shortLocale]);
        }

        this.$moment.locale(newValue.short_code);

        if (!oldValue || (oldValue && !oldValue.short_code)) {
          //this.addGameCastScript(shortLocale);
        } else if (oldValue.code !== newValue.short_code) {
          //this.addGameCastScript(shortLocale);
        }

        if (oldValue && oldValue.code !== newValue.code) {
          this.getMenuList();
          if (this.$route.matched[0] && this.$route.matched[0].meta && this.$route.matched[0].meta.locales) {
            this.$router.push(this.routerProvider.routeSwitchControl(this.$route));
          }
        }
      }
    },
    betSlipBetsCount(value, oldValue) {
      if (oldValue != value) {
        this.applyBetSlipIconAnim = true;
        setTimeout(() => {
          this.applyBetSlipIconAnim = false;
        }, 1000);
      }
    },
    $route(route, beforeRoute) {
      setLastVisit(route);
      this.setBody(route, beforeRoute);
      this.checkIdleForEpos(route);
      this.deployModalControl(route);
      this.redirectToChangePassword(this.clerk);
    },
    rePrintModal(value) {
      const route = this.$route;
      const isPrintOut = route.query.isPrintOut === true;

      if (isPrintOut) {
        if (value.show === false && value.counter === 10 && !!value.scanCode && value.isAnonym) {
          this.printYes();
          return;
        }

        if (value.show === false && value.counter === 40 && !!value.scanCode) {
          this.tryScanBarcode(this.rePrintModal.scanCode);
        }
      } else {
        if (value.show === false && value.counter === 10 && !!value.scanCode && value.isAnonym) {
          this.confirmDeposit(true, true);
          return;
        }
        if (value.show === false && value.counter === 40 && !!value.scanCode) {
          this.confirmDeposit(true, true);
        }
      }
    },
    countDownForIdleModal(val) {
      if (val === 0) {
        this.restStateForIdle();
      }
    },
    terminalInfo(val) {
      if (val) {
        this.checkIdleForEpos(this.$route);
      }
    },
  },
  computed: {
    ...mapFields('player', ['isClerk']),
    ...mapFields('settings', ['showScanBarcodeModal']),
    ...mapState({
      appLoading: state => state.settings.appLoading,
      languageLoading: state => state.settings.languageLoading,
      selectedLocale: state => state.settings.selectedLocale,
      terminalInfo: state => state.settings.terminalInfo,
      terminalExists: state => state.settings.terminalExists,
      betSlipBetCount: state => state.betSlip.betSlipBetCount,
      loginType: state => state.player.loginType,
      player: state => state.player.player,
      clerk: state => state.player.clerk,
      isLogged: state => state.player.isLogged,
      brandSettings: state => state.settings.brandSettings,
      macAddress: state => state.settings.macAddress,
      terminalInfoError: state => state.settings.terminalInfoError,
      newTerminalRequest: state => state.settings.newTerminalRequest,
      freeWagersViewing: state => state.freeWagerStore.freeWagersViewing,
      selectedFreeWager: state => state.freeWagerStore.selectedFreeWager,
      activeLeagueId: state => state.sportMenu.activeLeagueId,
      betsConfirmationModal: state => state.depositTicketStore.betsConfirmationModal,
      sportsBookPayoutSuccessModal: state => state.depositTicketStore.sportsBookPayoutSuccessModal,
      ticketAllBets: state => state.clerkPayoutDepositTicketStore.ticketAllBets,
      openWagerStatusModal: state => state.clerkPayoutDepositTicketStore.openWagerStatusModal,
      rePrintModal: state => state.settings.rePrintModal,
      depositStatus: state => state.clerkDepositStore.depositStatus,
      successModal: state => state.helper.successModal,
      errorModal: state => state.helper.errorModal,
      socketConnection: state => state.settings.socketConnection,
      showIdleModal: state => state.helper.showIdleModal,
      showSportsMenuModal: state => state.helper.showSportsMenuModal,
      isScanningCodeForMobile: state => state.settings.isScanningCodeForMobile,
    }),
    ...mapGetters({
      shouldDisableCasino: 'settings/shouldDisableCasino',
    }),
    isNotClerk() {
      return this.terminalInfo && this.terminalInfo.can_clerk_login != '1';
    },
    isClerk() {
      return this.terminalInfo && this.terminalInfo.can_clerk_login == '1';
    },
    pageUrl: function() {
      if (isElectron) {
        return 'electron';
      }

      if (document.domain === 'instabetmx-engine.dev.notavailable.mx') {
        const url = 'instabet.mx';
        // const url = this.$enviroment.VUE_APP__BRAND;
        return url.split('.')[0];
      }

      if (process.env.NODE_ENV === 'development') {
        // // const url = "apueston.mx";
        const url = 'instabet.com';
        // const url = this.$enviroment.VUE_APP__BRAND;
        return url.split('.')[0];
      }

      return document.domain
        .split('.')
        .reverse()
        .splice(0, 2)
        .reverse()
        .join('.')
        .split('.')[0];
    },
    betSlipBetsCount() {
      if (this.freeWagersViewing) {
        return Math.min(this.betSlipBetCount, this.selectedFreeWager.pick_count);
      }
      return this.betSlipBetCount;
    },
    isPartialLoading() {
      return this.languageLoading;
    },
    showCommonOverlay() {
      return (
        this.$store.state.betSlip.betPlaceStatus.loading ||
        this.$store.state.betSlip.registerBetStatus.loading ||
        this.$store.state.betSlip.printing
      );
    },
  },
  methods: {
    ...mapActions({
      setSelectedLocale: 'settings/setLocale',
      getTerminalInfo: 'settings/getTerminalInfo',
      logout: 'player/logout',
      getLoyaltyCardDetails: 'settings/getLoyaltyCardDetails',
      setShowScanBarcodeModal: 'settings/setShowScanBarcodeModal',
      connectSocket: 'betLines/connectSocket',
      disconnectSocket: 'betLines/disconnectSocket',
      getBetLines: 'betLines/getBetLines',
      getNewBetOptions: 'betSlip/getNewBetOptions',
      getBanners: 'settings/getBanners',
      getMenuList: 'sportMenu/getMenuList',
      setAppLoading: 'settings/setAppLoading',
      connectMenuSocket: 'sportMenu/connectMenuSocket',
      disconnectMenuSocket: 'sportMenu/disconnectMenuSocket',
      setReprintModal: 'settings/setReprintModal',
      tryScanBarcode: 'depositTicketStore/tryScanBarcode',
    }),
    ...mapActions('depositTicketStore', ['tryScanBarcode']),
    ...mapActions('clerkWagerStore', ['tryScanWagerBarcode']),
    ...mapActions('player', ['clearDeposit']),
    ...mapMutations({
      setLoginType: 'player/setLoginType',
      setBrowserIsIdle: 'betLines/setBrowserIsIdle',
      setBetsConfirmationModal: 'depositTicketStore/setBetsConfirmationModal',
      setSportsBookPayoutSuccessModal: 'depositTicketStore/setSportsBookPayoutSuccessModal',
      addCalc: 'depositTicketStore/addCalc',
      setEposVersion: 'helper/setEposVersion',
      setOpenWagerStatusModal: 'clerkPayoutDepositTicketStore/setOpenWagerStatusModal',
      vk_common_show: 'helper/vk_common_show',
      setDeployModalShow: 'deploy/setDeployModalShow',
      setShowIdleModal: 'helper/setShowIdleModal',
      setShowSportsMenuModal: 'helper/setShowSportsMenuModal',
    }),
    ...mapMutations('clerkDepositStore', ['setDepositStatus', 'setDisableWalletStatus']),

    closeSportsMenuModal() {
      this.setShowSportsMenuModal(false);
      document.body.classList.remove('no-scroll');
    },
    redirectToChangePassword(clerk) {
      if (this.isClerk && clerk && clerk.mustRedirectToPasswordChange) {
        this.$router.push('/clerk/change-password');
      }
    },
    reloadPage() {
      window.location.reload();
    },
    deployModalControl(route) {
      if (this.isClerk) {
        this.deployModalShowInternal = this.deployModalShow;
        return;
      }

      const isInSplash = route.name === 'start';
      if (isInSplash) {
        this.deployModalShowInternal = this.deployModalShow;
      } else {
        this.deployModalShowInternal = false;
      }
    },
    setDeployModalShow(val) {
      this.deployModalShow = val;
    },
    deployModalCountDownTimer() {
      if (this.deployModalCountDown > 0) {
        setTimeout(() => {
          this.deployModalCountDown -= 1;
          this.deployModalCountDownTimer();
        }, 1000);
      }
    },
    refreshEposTrigger() {
      this.setDeployModalShow(true);
      this.deployModalCountDown = 20;
      this.deployModalCountDownTimer();
    },
    deleteAllCookies() {
      Object.keys(Cookies.get()).forEach(key => Cookies.remove(key));
    },
    listenEposSocket() {
      if (!isElectron) {
        return;
      }

      const refreshEpos = () => {
        this.setDeployModalShow(true);
      };

      const getLanguage = async () => {
        store.commit('settings/setLanguageLoading', true);
        const res = await this.$store.dispatch('settings/getLocaleMessages');

        let selectedLocale = store.state.settings.selectedLocale;
        const defaultLanguage = snq(
          () => JSON.parse(this.terminalInfo.brand_settings.location_settings.available_languages),
          [],
        ).find(_ => _.is_default);
        let selectedLocaleCode =
          (selectedLocale && Object.keys(selectedLocale).length > 0 && selectedLocale.short_code) ||
          defaultLanguage.code;
        i18n.setLocaleMessage(selectedLocaleCode, res.data[selectedLocaleCode]);
        await this.$store.dispatch('settings/setLocale', selectedLocaleCode);
        window.Locale = res.data;
        store.commit('settings/setLanguageLoading', false);
      };

      const clearStorages = () => {
        this.deleteAllCookies();
        localStorage.clear();
        setTimeout(() => this.reloadPage(), 1000);
      };

      socket._menuSocket.subscribe('refreshEpos', args => {
        const { brand, customMacAddress, reloadType } = args;

        const maker = () => {
          if (reloadType === 'FE_Deploy') {
            refreshEpos();
          }

          if (reloadType === 'Get_Lang') {
            this.$toasted.show(i18n.t('Refreshing.Languages'), {
              type: 'info',
              position: 'bottom-center',
              duration: 3000,
            });
            getLanguage().then(_ => getLanguage().then());
          }

          if (reloadType === 'Clear_Storage') {
            clearStorages();
          }
        };

        if (brand === 'kiosk') {
          if (!!customMacAddress) {
            if (this.macAddress === customMacAddress) {
              maker();
            }

            return;
          }

          maker();
        }
      });
    },
    goIfLogged(path) {
      if (this.isLogged) {
        this.$router.push(path);
      } else {
        this.showNeedLoginModal = true;
      }
    },
    confirmDeposit(confirm, withBack = false) {
      const route = this.$route;
      const isDepositTicket = route.name === 'clerk-ticket-deposit';
      const isPrintOut = route.query.isPrintOut === true;

      if (
        (this.loginType === LoginTypes.Clerk || this.loginType === ExternalWagerLoginTypes.ClerkDepositTicket) &&
        isDepositTicket &&
        !isPrintOut
      ) {
        _api
          .post('/clerk/confirmdeposit', {
            wallet_id: snq(() => this.depositStatus.success.ticket_number),
            confirm,
          })
          .then(res => {
            if (!res.data.IsSuccess) {
              this.$modal.openErrorModal({
                content: snq(() => res.data.ExceptionMessage[0]) || 'Confirm.Error',
              });

              return;
            }
            if (confirm === true && !!res.data.IsSuccess) {
              // TODO: THERE CAN BE NaN BUG HERE
              this.addCalc({
                type: 'voucher',
                ticketNumber: this.depositStatus.success.ticket_number,
                amount: parseFloat(res.data.Data.data.SoldValue),
              });

              this.setDepositStatus({ openModalSuccess: true });

              if (withBack) {
                this.$router.go(-1);
              }
            }

            if (confirm === false && !!res.data.IsSuccess) {
              this.setDepositStatus({ openModalVoided: true });
            }
          });
      }
    },
    printNo() {
      const route = this.$route;
      const isPrintOut = route.query.isPrintOut === true;
      if (isPrintOut) {
        this.tryScanBarcode(this.rePrintModal.scanCode);
      } else {
        this.confirmDeposit(false);
      }
      this.setReprintModal({ show: false });
      this.$router.go(-1);
    },
    printYes() {
      const route = this.$route;
      const isPrintOut = route.query.isPrintOut === true;

      this.setReprintModal({ show: false });
      if (!isPrintOut) {
        this.confirmDeposit(true);
      } else {
        this.clearDeposit();
      }
      this.$router.go(-1);
    },
    getSentryContext() {
      return {
        macAddress: this.macAddress,
        version,
      };
    },
    checkLoginTypes() {
      // if (this.loginType === ExternalWagerLoginTypes.ClerkDepositTicket) {
      // this.setLoginType(LoginTypes.Clerk);
      // }
    },
    checkScanCode(e) {
      if (e.target.tagName !== 'INPUT') {
        if (e.keyCode === 13) {
          if (this.BarcodeScanCode) {
            const tempBarcode = this.BarcodeScanCode.trim();
            this.BarcodeScanCode = '';
            localStorage.setItem('PREF_SCAN_CODE', tempBarcode);
            console.log('ScanBarcode', tempBarcode);
            switch (tempBarcode.substring(0, 1)) {
              case 'C': //Loyalty card
                this.getLoyaltyCardDetails(tempBarcode);
                break;
              case 'D': //Depoist ticket
                if (this.isNotClerk) {
                  this.setShowScanBarcodeModal(true);
                  this.tryScanBarcode(tempBarcode);
                }
                break;
              case 'B': //Wager ticket
                if (this.isNotClerk) {
                  this.setShowScanBarcodeModal(true);
                  this.tryScanBarcode(tempBarcode);
                }
                break;
              default:
                break;
            }
          }
        } else {
          if (this.BarcodeScanCode === undefined) {
            this.BarcodeScanCode = e.key;
          } else if (e.key) {
            if (e.keyCode === 9) {
              return;
            }
            this.BarcodeScanCode += e.key;
          }
        }
      }
    },
    async addGameCastScript(locale) {
      // document.getElementById("widgetSrc").setAttribute('data-sr-language', locale);
      if (!this.brandSettings.is_game_cast_available) return;
      // log("[APP] adding game cast for locale: " + locale);

      // let script = document.getElementById("widgetSrc");
      // if (script) script.remove();

      // let recaptchaScript = document.createElement("script");
      // recaptchaScript.setAttribute("id", "widgetSrc");
      // recaptchaScript.setAttribute(
      //     "src",
      //     `https://widgets.sir.sportradar.com/a00bd5f17ebdc5b0a6b916a81bce9c79/widgetloader?r=${Math.floor(
      //         Math.random() * 100000000000000000000
      //     )}`
      // );
      // recaptchaScript.setAttribute("data-sr-language", locale);
      // document.head.appendChild(recaptchaScript);

      (function(a, b, c, d, e, f, g, h, i) {
        a[e] ||
          ((i = a[e] = function() {
            (a[e].q = a[e].q || []).push(arguments);
          }),
          (i.l = 1 * new Date()),
          (i.o = f),
          (g = b.createElement(c)),
          (h = b.getElementsByTagName(c)[0]),
          (g.async = 1),
          (g.src = d),
          g.setAttribute('n', e),
          h.parentNode.insertBefore(g, h));
      })(
        window,
        document,
        'script',
        'https://widgets.sir.sportradar.com/a00bd5f17ebdc5b0a6b916a81bce9c79/widgetloader',
        'SIR',
        {
          language: locale,
          theme: false,
          useTeamColors: false,
          waitForLicensing: true,
        },
      );
      SIR('changeLanguage', locale);
    },
    idleCheck() {
      if (idle) return;
      const timeout = this.brandSettings.idle_disccoencted_time || process.env.VUE_APP_IDLE_TIMEOUT;
      log('[APP] browser idle checker started with ' + timeout + ' ms');
      idle = new IdleJs({
        idle: timeout,
        events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
        onActive: () => {
          log('[APP] browser active');
          this.setBrowserIsIdle(false);
          setTimeout(() => {
            this.connectMenuSocket();
            this.connectSocket();
            this.getBetLines(this.activeLeagueId);
            this.getNewBetOptions({ getCheckeds: true });
          }, 100);
        },
        keepTracking: true,
        startAtIdle: false,
      });
      idle.start();
    },
    setBody(route, beforeRoute) {
      if (route) {
        document.body.classList.add(`route-` + route.name);
      }
      if (beforeRoute) {
        document.body.classList.remove(`route-` + beforeRoute.name);
      }
    },
    gtmInit: function(brand) {
      let id;
      switch (brand) {
        case 'instabet.com':
          id = 'GTM-T37NWTS';
          break;
        case 'instabet.net':
          id = 'GTM-MHK89DZ';
          break;
        case 'instabet.mx':
          id = 'GTM-WT8N3HJ';
          break;
      }
      if (brand) gtm.addGtm(id);
    },
    prepareGTM: function() {
      if (this.$isElectron) {
        return;
      }

      let brand;
      if (process.env.NODE_ENV === 'development') {
        brand = 'instabet.mx';
      } else {
        brand = document.domain
          .split('.')
          .reverse()
          .splice(0, 2)
          .reverse()
          .join('.');
        this.gtmInit(brand);
      }
    },
    gtmBugFix() {
      if (window.dataLayer) {
        const pushNew = window.dataLayer.push;

        window.dataLayer.push = function(a) {
          const isWrapper = a['gtm.elementClasses'] === 'bet-link-icon';
          const element = a['gtm.element'];
          const isBonus = element && element.closest('.route-bonus');

          a['gtm.elementUrl'] = '';

          if (!isWrapper && !isBonus) {
            pushNew.call(this, a);
          }
        };
      }
    },
    listenConsole() {
      if (isElectron && electron) {
        const ipc = electron.ipcRenderer;
        ipc.send('app-is-ready', true);
        ipc.on('app-log', (event, arg) => {
          console.log(`%c ${arg} `, 'background: #131e32; color: #fff');
        });
        ipc.on('set-version', (event, arg) => {
          console.log(`%c EPOS Application Version: ${arg} `, 'background: yellow; color: #000');
        });
      }
    },
    listenFocus() {
      const self = this;
      let activeElement = null;

      function debounce(callback, wait) {
        let timerId;
        return (...args) => {
          clearTimeout(timerId);
          timerId = setTimeout(() => {
            callback(...args);
          }, wait);
        };
      }

      setTimeout(() => {
        document.addEventListener(
          'click',
          debounce(event => {
            if (!event) return;
            const target = event.target;

            const isBetSlipInput =
              target.closest('.bet-scroll-wrapper') ||
              target.closest('.set-amount-all-bets-input') ||
              target.closest('.bet-slip-item-wrapper') ||
              target.closest('.barcode-scanner-modal');

            if (isBetSlipInput) {
              return;
            }
            const isFormControl = target.classList.contains('form-control');
            const virtualKeyPressed = target.closest('.simple-keyboard-common');

            if (isFormControl) {
              self.vk_common_show({ target: event.target, visible: true });
              activeElement = target;
            } else if (virtualKeyPressed) {
              // means keyboard button
              if (activeElement) {
                self.vk_common_show({ target: activeElement, visible: true });
                event.preventDefault();
              }
            } else {
              self.vk_common_show({ target: null, visible: false });
              activeElement = null;
            }
          }, 20),
        );
      }, 10000);
    },
    restStateForIdle() {
      this.setShowIdleModal(false);
      this.$store.commit('betSlip/resetBetSlip');
      this.$router.push({ name: 'start' });
      const terminalInfo = this.terminalInfo;
      const findDefault = item => item.is_default;
      const defOddType = JSON.parse(terminalInfo.brand_settings.location_settings.available_odd_types).find(
        findDefault,
      );
      const defLang = JSON.parse(terminalInfo.brand_settings.location_settings.available_languages).find(findDefault);
      const defTimezone = JSON.parse(terminalInfo.brand_settings.location_settings.available_timezones).find(
        findDefault,
      );

      this.$store.commit('settings/setDefaultTimeZone', defTimezone);
      this.$store.dispatch('settings/setLocale', defLang.short_code);
      //this.$store.dispatch('settings/setOddType', defOddType.code);
    },
    checkIdleForEpos(route) {
      if (this.terminalInfo && this.terminalInfo.can_clerk_login === '1') {
        return;
      }

      const isStartScreen = route.name === `start`;

      if (isStartScreen && idle2) {
        idle2.stop();
        idle2 = null;
      }
      if (isElectron && !isStartScreen) {
        if (idle2) return;

        idle2 = new IdleJs({
          idle: 180000,
          events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
          onIdle: () => {
            this.setShowIdleModal(true);
            this.countDownForIdleModal = 15;
            this.startCountDownForIdleModal();
          },
          onActive: () => {},
          keepTracking: true,
          startAtIdle: false,
        });
        idle2.start();
      }
    },
    startCountDownForIdleModal() {
      if (this.countDownForIdleModal > 0) {
        setTimeout(() => {
          this.countDownForIdleModal -= 1;
          this.startCountDownForIdleModal();
        }, 1000);
      }
    },
    iAmHere() {
      this.setShowIdleModal(false);
      this.countDownForIdleModal = -1;
    },
  },
  created() {
    const self = this;
    this.$headerController.autopilot();

    if (self.$isElectron) {
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('kiosk');
    }

    document.cookie = '';

    this.checkLoginTypes();
    // call idle check after brand settings because it needs configuration
    if (this.loginType === LoginTypes.Player) {
      startCheckInactivityAfterReload();
    }
    document.removeEventListener('keypress', e => {
      self.checkScanCode(e);
    });
    document.addEventListener('keypress', e => {
      self.checkScanCode(e);
    });
  },
  mounted() {
    setLastVisit(this.$route);
    this.setBody(this.$route);
    this.listenConsole();
    this.listenFocus();
    setTimeout(() => this.redirectToChangePassword(this.clerk), 2000);

    //MATOMO JS START

    // if (brand === "instabet.com") {
    //     var _mtm = _mtm || [];
    //     if (this.player.PlayerAccount)
    //         _mtm = [{userId: this.player.PlayerAccount}];
    //     _mtm.push({"mtm.startTime": new Date().getTime(), event: "mtm.Start"});
    //     var d = document,
    //         g = d.createElement("script"),
    //         s = d.getElementsByTagName("script")[0];
    //     g.type = "text/javascript";
    //     g.async = true;
    //     g.defer = true;
    //     g.src = "https://mtm.notavailable.mx/js/container_887DivUw.js";
    //     s.parentNode.insertBefore(g, s);
    // }
    // if (brand === "instabet.net") {
    //     var _mtm = _mtm || [];
    //     if (this.player.PlayerAccount)
    //         _mtm = [{userId: this.player.PlayerAccount}];
    //     _mtm.push({"mtm.startTime": new Date().getTime(), event: "mtm.Start"});
    //     var d = document,
    //         g = d.createElement("script"),
    //         s = d.getElementsByTagName("script")[0];
    //     g.type = "text/javascript";
    //     g.async = true;
    //     g.defer = true;
    //     g.src = "https://mtm.notavailable.mx/js/container_BVo2vfru.js";
    //     s.parentNode.insertBefore(g, s);
    // }

    // if (brand === "instabet.mx") {
    //     var _mtm = _mtm || [];
    //     if (this.player.PlayerAccount)
    //         _mtm = [{userId: this.player.PlayerAccount}];
    //     _mtm.push({"mtm.startTime": new Date().getTime(), event: "mtm.Start"});
    //     var d = document,
    //         g = d.createElement("script"),
    //         s = d.getElementsByTagName("script")[0];
    //     g.type = "text/javascript";
    //     g.async = true;
    //     g.defer = true;
    //     g.src = "https://mtm.notavailable.mx/js/container_kEx4Z9yr.js";
    //     s.parentNode.insertBefore(g, s);
    // }

    //MATOMO JS END
    // document.body.addEventListener("click", function(e) {
    //     // e.target was the clicked element
    //     if(e.target && e.target.nodeName == "A") {
    //         e.preventDefault()
    //         e.stopPropagation()
    //         newwindow = window.open(e.target.href,'popupWindow','height=400,width=300');
    //         if (window.focus) {newwindow.focus()}
    //         return false;
    //     }
    // });

    window.addEventListener('load', event => {
      if (navigator.userAgent.indexOf('Chrome-Lighthouse') === -1) {
        this.$zendeskController.create();
        this.$headerController.facebook();
        this.$pixelAd.conversion();
        this.prepareGTM();
        this.gtmBugFix();

        if (!this.$isElectron) {
          insertHotjar();
        }

        setTimeout(() => {
          const locale = Cookies.get('locale');
          window.zE && zE('webWidget', 'setLocale', locale);
          if (window.zE) {
            zE('webWidget:on', 'chat:end', function() {
              console.log('live chat end');
              const chatBubble = document.getElementById('launcher');
              chatBubble.style.display = 'none';
              $zopim.livechat.window.toggle();
            });
          }
        }, 1000);
      }
    });
  },
};
</script>

<style lang="scss">
@import './sass/app.scss';
#launcher {
  display: none;

  //@media screen and (max-width: 767px) {
  //  display: block !important;
  //}
}
.loading-dots {
  transition: all ease-in 0.2s;

  &:after {
    content: '.';
    animation: dots 1s steps(5, end) infinite;
  }
}

@keyframes dots {
  0%,
  20% {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  40% {
    color: black;
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 black, 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  80% {
    text-shadow: 0.25em 0 0 black, 0.5em 0 0 black;
  }
  100% {
    text-shadow: 0.25em 0 0 black, 0.5em 0 0 black;
  }
}

.betslip-icon-anim {
  animation: betslip-icon-animate 0.4s cubic-bezier(0.785, 0.135, 0.15, 0.86) both;
}

@keyframes betslip-icon-animate {
  0% {
    transform: scale(3);
  }
  100% {
    transform: scale(1);
  }
}

body.kiosk {
  .toasted-container {
    z-index: 99999999;
    .toasted-primary.info {
      background-color: var(--color1);
    }
  }
  .refresh-trigger-area {
    position: fixed;
    left: 40px;
    bottom: 40px;
    background-color: var(--color8);
    color: #fff;
    z-index: 999999999;
    border-radius: 5px;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.3);
    padding: 10px;
    width: 250px;
    border: 2px solid rgba(225, 225, 225, 0.3);

    .rta-title {
      font-size: 17px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      .rta-loading-count {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        border: 3px solid green;
        margin-right: 10px;
        font-size: 12px;
      }
    }

    .btn {
      width: calc(50% - 5px);
      margin-right: 10px;
      background-color: #fff;
      border-radius: 3px;

      &:last-child {
        margin-right: 0;
      }

      &.refresh-button {
        background-color: #396afb !important;
        color: #fff;
      }
    }
  }
}

.idle-modal {
  .modal__container {
    max-width: 610px !important;
    width: 610px !important;
    background-color: #2a3550 !important;
  }

  .modal-icon {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }

  h2 {
    color: #b5c8ff;
    font-size: 28px;
    margin-bottom: 17px;
  }

  p {
    font-size: 22px;
    color: #7083ba;
    margin-button: 36px;
  }

  .buttons {
    display: flex;
    padding: 0 70px;

    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(100% - 13px);
      color: #fff !important;
      width: 223px !important;

      &.here {
        margin-right: 26px;
      }
      &.reset {
        border: 1px solid #fff;
      }

      &:hover {
      }
    }
  }
}
.common-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10000;
  font-size: 60px;
  color: #fff;
}
</style>
